<template>
  <div class="container-fluid current-sale-line">
    <div class="row">
      <div class="line-description-pane col-5">
        <h6 class="line-description">
          {{ $utils.toPascalCase($utils.cutLength(sale.Description, 30)) }}<br>
        </h6>
        <h5 class="text-success text-sm " v-if="sale.Discount>0">{{ `Discount ${$utils.formatMoney(saleLine.Discount)}` }}</h5>
      </div>
      <div class="d-flex flex-column justify-content-between line-prices-pane col-7">
        <div class="price-row">
          <p class="price-label mx-2">Item Price: <span
              class="line-price">{{ $utils.formatMoney(sale.Unit / rate, 2, '.', ',', true,symbol) }}</span></p>
          <p class="price-label">Total: <span
              class="line-price">{{ $utils.formatMoney(((sale.Unit * sale.Qty ) - sale.Discount + instructionTotal) / rate, 2, '.', ',', true,symbol) }}</span>
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <ul class="cooking-instruction-list" v-if="hasInstructions">
        <li class="cooking-instruction-list-item" v-for="instruction in instructions">
          {{ instruction.CookingMsg }} <span>{{ instruction.count }} X {{
            $utils.formatMoney(instruction.Price / rate, '.', ',', true,symbol)
          }}</span>
          Total: {{ $utils.formatMoney(instruction.count * instruction.Price / rate, '.', ',', true,symbol) }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ForeignCurrencySaleLine',
  props: {
    sale: {
      type: Object,
      required : true,
    },
    rate : {
      type: Number,
      required : true,
    },
    symbol : {
      type: String,
      required : true,
    },
  },
  computed: {
    hasInstructions() {
      return (this.sale.instructions && this.sale.instructions.length > 0)
    },
    instructionTotal() {
      if (!this.sale.instructions || this.sale.instructions.length === 0) return 0.00;
      let total = this.sale.instructions.map(i => i.Price).reduce((acc, n) => Number(n) + Number(acc))
      if (isNaN(total)) {
        return 0.00;
      }
      return Number(total.toFixed(2))
    },
    instructions() {
      return this.sale.instructions.map((int) => {
        int.Price = Number(int.Price.toFixed(2))
        return int;
      });
    }
  }
}
</script>
<style lang="scss" scoped>
.current-sale-line {
  padding: 10px;
  min-height: 95px;
  margin-bottom: 5px;

  .row {
    .line-description-pane {
      .line-description {
        font-size: 18px;
        margin: 0;
        line-height: 18px;
        font-weight: 500;
      }
    }

    .line-prices-pane {
      .price-label {
        font-size: 12px;
        margin: 0;

        .line-price {
          font-size: 15px;
          font-weight: 700;
        }
      }
    }
  }
}

button {
  background-color: transparent;
}

.cooking-instruction-list {
  list-style: inside;

  .cooking-instruction-list-item {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    color: #404040;
    display: flex;
    justify-content: space-between;
  }
}

.price-row {
  display: flex;
  flex-direction: row;
}

.text-sm{
  font-size: 12px;
}
#discount-btn {
  padding: 2px;
  border-radius: 5px;
}
</style>